import { useEffect } from "react";
import { useFormContext } from "react-hook-form";

import type { ValidationKey } from "@covertree/new-business-forms";

import { getUnitCoverageFormPath } from "@redux/slices/endorsement/extraCoverageFields";

/** Revalidates all coverage fields when any of them changes, like NBS. */
export const useRevalidateOnChange = (keys: ValidationKey[]) => {
  const { trigger, watch } = useFormContext();

  useEffect(() => {
    const paths = keys.map(getUnitCoverageFormPath);

    const { unsubscribe } = watch((_, { name }) => {
      if (keys.some((key) => name?.endsWith(`.${key}`))) void trigger(paths);
    });

    return unsubscribe;
  }, [keys, trigger, watch]);
};
